import React, { useState, useEffect, useCallback } from 'react';
import styles from './index.module.sass';
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from 'react-i18next';
import Alert from '../../Alert';
import OrderCard from '../../OrderCard';
import SectionTitle from '../../SectionTitle';
import GetCatalogoRegimenFiscal from '../../Queries/GetCatalogoRegimenFiscal';
import getRegimenFiscalKit from '../../Queries/getRegimenFiscalKit';
import AlertConfirm from '../AlertConfirm';
import getGlobal from '../../Queries/getGlobal';
import getCookie from '../../Queries/getCookie';

const TaxData = (props) => {
  const { device } = props;
  const { screenSize } = device;
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation('taxData');
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [arrayRegimen, setRegimen] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [valuesForm, setvaluesForm] = useState({
    cp: '',
    regFis: '',
    rfc: '',
    name: '',
    paterno: '',
    materno: '',
  });

  async function submit() {
    if (disabled) {
      return;
    }

    if (valuesForm.rfc.length !== 13) {
      setAlertText(t('alertRFC'));
      setOpen(true);
      return;
    }

    setAlertText(t('question2'));
    setOpenConfirm(true);
    return;
  }

  const searchRegimen = useCallback(async () => {
    const response = await GetCatalogoRegimenFiscal();
    const { CatRegFisc = [], typeMessage = 'error' } = response;
    if (typeMessage === 'success') {
      setRegimen(CatRegFisc);
    }
  }, []);

  const getRegimenFiscal = useCallback(async () => {
    setLoading(true);
    const response = await getRegimenFiscalKit();
    const {
      typeMessage = 'error',
      regimenFiscal = '',
      codigoPostalFiscal = '',
      Rfc = '',
      nombre = '',
      paterno = '',
      materno = '',
      message = '',
    } = response;

    if (typeMessage === 'success') {
      setvaluesForm({
        cp: codigoPostalFiscal,
        regFis: regimenFiscal,
        rfc: Rfc,
        name: nombre,
        paterno: paterno,
        materno: materno,
      });
      setLoading(false);
    } else {
      setAlertText(message);
      setOpen(true);
      setLoading(false);
      return;
    }
  }, []);

  const postRegimen = useCallback(async () => {
    setLoading(true);
    setOpenConfirm(false);

    const responseRegFis = await getGlobal({
      tmbservice: 'GetActualizaRegimenFiscal',
      jsonBody: {
        usuarioOK: getCookie('usuarioOk'),
        CodRegFisc: valuesForm.regFis,
        CodPostalFisc: valuesForm.cp,
        Nombre: valuesForm.name.toUpperCase(),
        Paterno: valuesForm.paterno.toUpperCase(),
        Materno: valuesForm.materno.toUpperCase(),
        Rfc: valuesForm.rfc.toUpperCase(),
      },
    });

    if (responseRegFis?.GetActualizaRegimenFiscalResult?.typeMessage !== 'success') {
      setAlertText(responseRegFis?.GetActualizaRegimenFiscalResult?.message);
      setLoading(false);
      return;
    } else {
      setAlertText(t('success'));
      setOpen(true);
      setLoading(false);
      setDisabled(true);
      return;
    }
  }, [
    valuesForm.cp,
    valuesForm.regFis,
    valuesForm.name,
    valuesForm.rfc,
    valuesForm.paterno,
    valuesForm.materno,
    t,
  ]);

  useEffect(() => {
    searchRegimen();
    getRegimenFiscal();
  }, [searchRegimen, getRegimenFiscal]);

  const changeValue = (e) => {
    setDisabled(false);
    setvaluesForm({
      ...valuesForm,
      [e.target.name]: e.target.value,
    });
  };

  function restrictChars($event) {
    if ($event.charCode === 0 || /\d/.test(String.fromCharCode($event.charCode))) {
      return true;
    } else {
      $event.preventDefault();
    }
  }

  return (
    <div className={`${styles[screenSize]} ${styles.documents}`}>
      <SectionTitle title={t('title')} subtitle={t('subtitle')} />
      <Alert open={open} setOpen={setOpen} title={t('alertTitle')} text={alertText} />
      <AlertConfirm
        openConfirm={openConfirm}
        setOpenConfirm={setOpenConfirm}
        title={t('alertTitle')}
        text={alertText}
        callback={postRegimen}
        setLoading={setLoading}
      />
      <div className={screenSize !== 'phone' ? styles.container : styles.containerMobile}>
        <div className={screenSize !== 'phone' ? styles.formDocuments : styles.formDocumentsMobile}>
          <OrderCard>
            <div className={styles.regFiscal}>
              <div className={styles.label}>
                <label>{t('rfc')}</label>
              </div>
              <div className={styles.RegimenFiscal}>
                <input
                  type='text'
                  name='rfc'
                  autoComplete='off'
                  placeholder={t('rfc')}
                  maxLength='13'
                  onKeyPress={(e) => restrictChars(e)}
                  onChange={(e) => changeValue(e)}
                  value={valuesForm.rfc}
                  className={styles.inputSelect}
                />
              </div>

              <div className={styles.label}>
                <label>{t('name')}</label>
              </div>

              <div className={styles.RegimenFiscal}>
                <input
                  type='text'
                  name='name'
                  autoComplete='off'
                  placeholder={t('namePlaceholder')}
                  onChange={(e) => changeValue(e)}
                  value={valuesForm.name}
                  className={styles.inputSelect}
                />
              </div>

              <div className={styles.label}>
                <label>{t('name1')}</label>
              </div>

              <div className={styles.RegimenFiscal}>
                <input
                  type='text'
                  name='paterno'
                  autoComplete='off'
                  placeholder={t('lastName')}
                  onChange={(e) => changeValue(e)}
                  value={valuesForm.paterno}
                  className={styles.inputSelect}
                />
              </div>

              <div className={styles.label}>
                <label>{t('name2')}</label>
              </div>

              <div className={styles.RegimenFiscal}>
                <input
                  type='text'
                  name='materno'
                  autoComplete='off'
                  placeholder={t('secondLastName')}
                  onChange={(e) => changeValue(e)}
                  value={valuesForm.materno}
                  className={styles.inputSelect}
                />
              </div>

              <div className={styles.label}>
                <label>{t('regimen')}</label>
              </div>
              <div className={styles.RegimenFiscal}>
                <select
                  className={styles.inputSelect}
                  name='regFis'
                  onChange={(e) => changeValue(e)}
                  value={valuesForm.regFis}>
                  <option value=''>{t('tax')}</option>
                  {arrayRegimen.map((val, key) => {
                    return (
                      <option key={key} value={val.codigo}>
                        {`${val.codigo} - ${val.descripcion}`}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className={styles.label}>
                <label>{t('zipCode')}</label>
              </div>
              <div className={styles.RegimenFiscal}>
                <input
                  type='text'
                  name='cp'
                  autoComplete='off'
                  placeholder='00000'
                  maxLength='5'
                  onKeyPress={(e) => restrictChars(e)}
                  onChange={(e) => changeValue(e)}
                  value={valuesForm.cp}
                  className={styles.inputSelect}
                />
              </div>
            </div>
            {!loading ? (
              <div>
                <div
                  className={!disabled ? styles.button : styles.buttonDisable}
                  onClick={() => submit()}>
                  <div>{t('save')}</div>
                </div>
              </div>
            ) : (
              <div className={styles.loadingDiv}>
                <CircularProgress className={styles.loading} />
              </div>
            )}
          </OrderCard>
        </div>
      </div>
    </div>
  );
};

export default TaxData;
